var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.9 82.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.92,26.3c-2.1,1.6-4,3.2-6,3.9-1.3,.4-2.6,.6-3.9,1-7,2.2-11.1,9.5-17.7,12.8-1.4,.7-2.9,1.2-4.3,2s-2.6,2-2.9,3.6c-.3,1.2,0,2.5,.6,3.7,1.8,3.6,5.6,5.7,9.4,7.1,3.3,1.3,6.6,2.3,10,3.1,4.6,1.1,7.9,.8,14.2,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.42,29.3c3.7,1.7,6.8,4.6,8.7,8.2s2.6,7.8,1.9,11.8c-.5,3.1-1.8,5.9-3.1,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M60.22,14.8c2.3-4.1,11-11,16.5-12.8,0,0,37.7,16.2,49.3,27.8l-2.1,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.42,67.6c5.1,2.5,5.4,3.5,15.5,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M50.72,54.6c4,2,8.1,3.9,11.8,6.4,1.8,1.2,3.3,2.5,4.7,4.1,.5,.6,2.4,2.8,2.4,2.8-2,1.4-3.8,2.1-6.3,2.3-1.8,.1-3.6-.1-5.4-.5l-2.8-.7-2.9-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M82.92,77.6c-.6,.1-1.3,.1-1.9,.2-9.8,.7-19.8-.3-29.1-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M97.72,74.9c.6-.6,1.1-1.3,1.6-2.1,.1-.2,.3-.4,.4-.5,0,0-4.6-2.1-5.2-2.3-2.7-1.1-5.8-2.1-9.4-3-.8-.2-2.8-.5-2.8-.5l-.9-.1c-2.3-.2-4.3,1.5-4.6,3.7,1.1,2.9,4.3,6,6.1,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M82.92,77.6c.1,0,.1,.1,0,0,.5,.4,4.9,3.3,4.9,3.3,1.6-.6,1.4-.5,2.3-.9,2.9-1.3,5.5-2.9,7.5-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M129.62,62.9l2.7,2.4s-3,4.3-3.4,7.1-.5,6.6-.5,6.6c-.1,0-3.2-1-5.8-2.1-4.3-1.8-10.5-7.1-10.5-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M150.72,31.6c4.8-4.4,10.4-8.6,16.6-11,2-.8,7.9-2.8,9-2.5,1.5,.5,2,2,1.2,4.4-.4,.9-3.3,9.6-3.3,9.6,0,0-2.7,5.8-3.8,7-2.9,3.2-7.7,5.9-6.7,10.8,.9,4.4,5.2,7,7.8,10.3,3.3,4.3,4.1,9.9,5.9,14.9,.8,2.2,.3,3.8-1.2,4.4-1.1,.5-7-1.7-9-2.5-3.4-1.3-6.5-3.4-9.6-5.2-1.5-.9-4.3-3.4-7-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.52,28.3c7.9-6.9,16.2-11,26.4-13.7,9.4-2.5,20.8-.3,29.9,3.4,9.5,3.9,16.2,6.5,25.2,11.3,4.7,2.5,11.5,7.7,20.8,8.4,4.4,.3,8.7-1.3,12-4.3,.6-.6,1.3-1.2,1.9-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M150.72,66.1c-1.1-1-2.1-1.9-3-2.7-3-2.8-6.9-4.4-11-4.2-4.5,.2-7.9,2.4-12.6,4.5-7.3,3.2-13.6,7-21.1,9.6-1.8,.6-3.6,1.2-5.5,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M138.42,58.7c3.4-3.7,3.4-15,0-20.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 23.32,
    cy: 45.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M73.52,13.3c2.6-3,6.9-5.5,10.4-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M84.82,15.9c2.1-2.3,5.6-4.5,8.2-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M95.72,20c2.6-2.7,4.1-3.6,6.7-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.92,24.4c2.7-2.5,2.9-2.6,5.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M114.82,28.3c2.7-2.5,1.7-1.6,4.3-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M85.92,72.6h0c2.6,1,5.6,2.7,7.2,5l.1,.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M59.22,64.2c1.5,1.1,4.2,3.8,5.1,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M26.62,64.3c5.2-1.2,6.6-4.5,7.8-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.82,44.8c9-1.3,13.1-6.9,16.8-9.5,4-2.8,10.7-7.4,16.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.82,53c9,1.3,13.1,6.9,16.8,9.5,4,2.8,11.1,7.4,17.2,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.12,48.7c5.6,.2,11.1,1,16.7,.6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarp);
export default __webpack_public_path__ + "static/media/Carp.9d79f0ce31a26c2f9040ac923586e0a8.svg";
export { ForwardRef as ReactComponent };